//@ts-check

// var mixpanel = require("mixpanel-browser")
// window["mixpanel"] = mixpanel

// initMixpanel(window["config"]?.MIXPANEL_ID)

function initMixpanel(mixpanelId) {
  // mixpanel.init(mixpanelId)
  let uid = getUserIdFromAccessTokenCookie()
  log("Init using: " + uid)
  //@ts-ignore Expected 8 arguments but got 1 (what??)
  // mixpanel.identify(uid)
}

function getUserIdFromAccessTokenCookie() {
  let jwtMatch = document.cookie.match(
    new RegExp(getAccessTokenCookieName() + "=(.*?);"),
  )
  let uid
  if (jwtMatch) {
    let jwt = jwtMatch[1]
    let userInfo = JSON.parse(atob(jwt.split(".")[1]))
    uid = userInfo.sub.split("|")[1]
  }
  return uid
}

function getWindowConfig(key) {
  return window["config"] && window["config"][key]
}

/**
 * This function tracks an event on mixpanel.
 * @param {String} eventName - Registered event name in mixpanel.
 * @param {Object} [metadata] - Object containing event specific data.
 */
export function track(eventName, metadata) {
  try {
    // mixpanel.track(eventName, metadata)
  } catch (error) {
    console.log(error)
  }
}

/**
 * @param eventName {string}
 * @param func {function}
 * @param [metadata] {object}
 * @returns {function}
 */
export function trackAndCall(eventName, func, metadata) {
  return function() {
    try {
      // mixpanel.track(eventName, metadata)
    } catch (error) {
      console.log(error)
    }
    func.apply(null, arguments)
  }
}

function getAccessTokenCookieName() {
  if (location.href.match(/stage/)) {
    return "stageaccess_token"
  } else if (location.href.match(/dev|demo/)) {
    return "devaccess_token"
  } else {
    return "access_token"
  }
}

/**
 * Log to console.log during development (ANALYTICS_DEBUG is on)
 */
function log(...args) {
  if (getWindowConfig("ANALYTICS_DEBUG")) {
    console.log.apply(console, args)
  }
}

export function setUserInfo({ email, name, picture, ...props }) {
  if (getWindowConfig("ANALYTICS_DEBUG")) {
    console.log("Set User Info", arguments[0])
  }
  // mixpanel.people.set({
  //   $email: email,
  //   $avatar: picture,
  //   $name: name,
  //   ...props,
  // })
}
